import { useRouter } from 'next/router';

export function useStateKey() {
  const router = useRouter();
  const stateKey = router.query.state_key;

  if (typeof stateKey === 'string') {
    return stateKey;
  }
}
